<template>
  <div class="idCardLoading">
   
  </div>
</template>

<script>
export default {
  name: "idCardLoading",
  data() {
    return {
      time: 0,
      timer: null,
    };
  },
  async mounted() {
    this.$JSBridge.send("serviceType", { type: "12" });
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped lang="scss">
.idCardLoading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f5f5f5;
}
</style>
